import { Toaster as Sonner } from 'sonner';

import { useTemaActual as useTema } from '@/lib/TemaProvider';

/** Toasts (sustituye Toastr): arriba a la derecha, con los colores del legacy (skill §16). */
export function Toaster() {
  const { tema } = useTema();
  return (
    <Sonner
      theme={tema}
      position="top-right"
      richColors
      closeButton
      toastOptions={{ style: { fontFamily: 'var(--font-sans)', borderRadius: 14 } }}
    />
  );
}
